<span class="tracking" *ngFor="let link of trackingNumbers">
  <a [href]="link.url" target="_blank">{{link.number}}</a>
</span>
